import { useMemo } from 'react';
const useEnumOptions = (enumMap) => {
    return useMemo(() => {
        const enumOptions = enumMap ? Object.entries(enumMap) : [];
        return enumOptions;
    }, [enumMap]);
};
export default useEnumOptions;
